const styles = (theme) => ({
  link: {
    fontSize: '16px',
    color: theme.color.black_11,
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  icon: {
    width: 20,
    height: 20,
  },
  avatar: {
    background: theme.color.black_11,
    fontSize: 16,
  },
});

export default styles;
